export const MAX_KEYS          = 3;
// The host browsers dial for RTMP ingest, the HTTP-FLV preview and SRT. It is
// the same host that serves this dashboard, but it is NOT read from
// window.location: under `npm start` that is localhost:3000, which is not an
// ingest endpoint. Override per build with REACT_APP_INGEST_HOST.
export const INGEST_HOST       = process.env.REACT_APP_INGEST_HOST || "studio.fennira.com";
export const CHUNK_SIZE        = 50 * 1024 * 1024; // 50 MB
export const SRT_POLL_INTERVAL = 5000;

// The uploaded-video library used to be polled every second. Each poll walked
// the user's upload directory on the server, so the cost scaled with
// (signed-in users x videos each) and landed on the same single Node thread
// that serves the streaming control plane — it was the app's real concurrency
// ceiling, not the streaming itself.
//
// 10s is safe because the library only changes in response to actions this
// dashboard takes, and each of those refreshes it immediately: upload completion
// calls fetchVideos(), and both delete paths either call it or apply the list
// the server returns. The interval is a safety net for changes made in another
// tab or session, not the primary update path.
export const VIDEO_POLL_INTERVAL = 10000;

// Fennira brand palette (see src/fennira-brand.css, copied from fennira.com),
// applied to the dark dashboard. Key names are unchanged from the old
// near-black/cyan theme so every component picks the new values up as-is:
// `cyan` is now the brand teal and `green` the "live/sending" colour, which is
// deliberately lighter than teal so "sending" never reads as "button".
export const COLORS = {
  bg:           "#100F27",
  band:         "#141333",
  panel:        "#1C1A44",
  raised:       "#2A2760",
  panelSoft:    "rgba(239, 227, 204, 0.04)",
  input:        "#0B0A1F",
  border:       "rgba(239, 227, 204, 0.10)",
  borderStrong: "rgba(239, 227, 204, 0.20)",
  text:         "#EFE3CC",
  textSoft:     "#D9CFBC",
  muted:        "#ABA5C9",
  cyan:         "#2BBDAF",
  accent:       "#18A598",
  onAccent:     "#12112B",
  green:        "#3DD68C",
  amber:        "#F4B740",
  red:          "#F0686C",
  dangerFill:   "#D23B40",
  dangerSoft:   "rgba(229, 72, 77, 0.12)",
  fontDisplay:  "'Bricolage Grotesque', 'DM Sans', sans-serif",
  fontSans:     "'DM Sans', system-ui, sans-serif",
  fontMono:     "'JetBrains Mono', ui-monospace, Consolas, monospace",
  facebook:     "#3B82F6",
  youtube:      "#EF4444",
  // Each platform's own brand colour, so a destination is recognisable at a
  // glance in the list rather than by reading its label.
  linkedin:     "#0A66C2",
  x:            "#E7E9EA",
  instagram:    "#E1306C",
  kick:         "#53FC18"
};

